import { useCallback } from 'react';
import { DateRangeFilterSelect } from '../../../commonUI/DateRangeFilterSelect/DateRangeFilterSelect';
import { StrictDateRange } from '../../../commonUI/DateRangeFilterSelect/types';
import { useGrapeReportDateRangeKeys } from '../hooks/useGrapeReportDateRangeKeys';

type Props = {
  onChange: (value: StrictDateRange) => void;
};

export const ClusterGradingDateRangeSelect = ({ onChange }: Props) => {
  const handleChange = useCallback(
    (range: StrictDateRange | null) => {
      if (range) {
        onChange(range);
      }
    },
    [onChange]
  );

  const dateRangeOptions = useGrapeReportDateRangeKeys();

  return (
    <DateRangeFilterSelect onChange={handleChange} options={dateRangeOptions} />
  );
};
